export default __webpack_public_path__ + "static/media/logo-light.5346a0c3.svg";